export const productDetails = [
  {
    year: 2022,
    month: 9,
    day: 3,
    orderNumber: 1234567890123456,
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220520/873c30ce7d7f4.png'],
    title: '물에 타먹는 제주 수제 감귤칩(10봉지x1BOX)',
    price: 22500,
    howMany: 1,
  },
  {
    year: 2022,
    month: 9,
    day: 3,
    orderNumber: 1234567890123456,
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220520/873c30ce7d7f4.png'],
    title: '물에 타먹는 제주 수제 감귤칩(10봉지x1BOX)',
    price: 22500,
    howMany: 1,
  },
  {
    year: 2022,
    month: 9,
    day: 3,
    orderNumber: 1234567890123456,
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220520/873c30ce7d7f4.png'],
    title: '물에 타먹는 제주 수제 감귤칩(10봉지x1BOX)',
    price: 22500,
    howMany: 1,
  },
  {
    year: 2022,
    month: 9,
    day: 3,
    orderNumber: 1234567890123456,
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220520/873c30ce7d7f4.png'],
    title: '물에 타먹는 제주 수제 감귤칩(10봉지x1BOX)',
    price: 22500,
    howMany: 1,
  },
  {
    year: 2022,
    month: 9,
    day: 3,
    orderNumber: 1234567890123456,
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220520/873c30ce7d7f4.png'],
    title: '물에 타먹는 제주 수제 감귤칩(10봉지x1BOX)',
    price: 22500,
    howMany: 1,
  },
  {
    year: 2022,
    month: 9,
    day: 3,
    orderNumber: 1234567890123456,
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220520/873c30ce7d7f4.png'],
    title: '물에 타먹는 제주 수제 감귤칩(10봉지x1BOX)',
    price: 22500,
    howMany: 1,
  },
  {
    year: 2022,
    month: 9,
    day: 3,
    orderNumber: 1234567890123456,
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220520/873c30ce7d7f4.png'],
    title: '물에 타먹는 제주 수제 감귤칩(10봉지x1BOX)',
    price: 22500,
    howMany: 1,
  },
  {
    year: 2022,
    month: 9,
    day: 3,
    orderNumber: 1234567890123456,
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220520/873c30ce7d7f4.png'],
    title: '물에 타먹는 제주 수제 감귤칩(10봉지x1BOX)',
    price: 22500,
    howMany: 1,
  },
  {
    year: 2022,
    month: 9,
    day: 3,
    orderNumber: 1234567890123456,
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220520/873c30ce7d7f4.png'],
    title: '물에 타먹는 제주 수제 감귤칩(10봉지x1BOX)',
    price: 22500,
    howMany: 1,
  },
  {
    year: 2022,
    month: 9,
    day: 3,
    orderNumber: 1234567890123456,
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220520/873c30ce7d7f4.png'],
    title: '물에 타먹는 제주 수제 감귤칩(10봉지x1BOX)',
    price: 22500,
    howMany: 1,
  },
  {
    year: 2022,
    month: 9,
    day: 3,
    orderNumber: 1234567890123456,
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220520/873c30ce7d7f4.png'],
    title: '물에 타먹는 제주 수제 감귤칩(10봉지x1BOX)',
    price: 22500,
    howMany: 1,
  },
  {
    year: 2022,
    month: 9,
    day: 3,
    orderNumber: 1234567890123456,
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220520/873c30ce7d7f4.png'],
    title: '물에 타먹는 제주 수제 감귤칩(10봉지x1BOX)',
    price: 22500,
    howMany: 1,
  },
];
